// Pantallas abiertas: funcionan sin login y sin credencial.
const SCREEN_PATHS = {
  "/cocina": "cocina",
  "/recepcion": "recepcion",
  "/cajaRecepcion": "caja",
  "/bandejasRecepcion": "bandejas",
  "/ordenes-trabajo": "ordenesTrabajo",
};

export const getScreenName = (pathname = window.location.pathname) =>
  Object.entries(SCREEN_PATHS).find(([path]) => pathname === path || pathname.startsWith(`${path}/`))?.[1];

// Credencial del totem, también para las páginas a las que vuelve después del pago. El totem
// está deshabilitado (sin rutas); se conserva para reactivarlo.
export const getTotemToken = () => {
  try { return localStorage.getItem("comedor_screen_totem") || ""; } catch (_) { return ""; }
};

const APP_TOKEN_KEY = "comedor_app_token";
let appTokenEnMemoria = "";

// Vencimiento (exp) del token, sin verificar la firma: eso lo hace la API.
const tokenVencido = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    return typeof payload.exp === "number" && payload.exp * 1000 <= Date.now();
  } catch (_) { return false; }
};

const descartarAppToken = () => {
  appTokenEnMemoria = "";
  try { sessionStorage.removeItem(APP_TOKEN_KEY); } catch (_) { /* Sin almacenamiento */ }
};

// El token de la app llega una vez en el enlace de ingreso (?token=). Se quita de la
// dirección, para que no quede en el historial ni viaje al copiar o compartir el link, y se
// guarda solo en esta pestaña (sessionStorage): se borra al cerrarla y se descarta al vencer,
// para que otra persona que use el mismo navegador no entre con él. También se envía al
// handshake WS.
export const captureAppToken = () => {
  const url = new URL(window.location.href);
  const nuevo = url.searchParams.get("token");
  if (nuevo) {
    url.searchParams.delete("token");
    window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`);
    if (tokenVencido(nuevo)) {
      descartarAppToken();
      return "";
    }
    appTokenEnMemoria = nuevo;
    try { sessionStorage.setItem(APP_TOKEN_KEY, nuevo); } catch (_) { /* Sin almacenamiento: queda solo en memoria */ }
    return nuevo;
  }
  let guardado = appTokenEnMemoria;
  try { guardado = sessionStorage.getItem(APP_TOKEN_KEY) || appTokenEnMemoria; } catch (_) { /* Sin almacenamiento */ }
  if (guardado && tokenVencido(guardado)) {
    descartarAppToken();
    return "";
  }
  return guardado;
};

export const getAppToken = () => {
  if (window.location.pathname !== "/sistema-comedor") return "";
  return captureAppToken();
};

export const getTransportCredentials = () => {
  let session = "";
  try { session = JSON.parse(localStorage.getItem("user") || "null")?.token || ""; } catch (_) { /* Sin sesión */ }
  const app = getAppToken();
  // Una pantalla abierta o la app no heredan una sesión de personal que quedó en el navegador.
  return { Authorization: getScreenName() || app ? "" : session, AppToken: app };
};
